export const PHQ9 = 
{
    Metadata:{Name:'PHQ-9',maxColumn:4,numRows:10},
    Sections:
    [
        {
            Headers:[
                "<span class='importantText'>Over the last 2 weeks</span> how often have you been bothered by the following problems",
                "Not at all",
                "Several Days",
                "More then half the days",
                "Nearly every day"
            ],
            Questions:[
                {
                    Prompt:"1. Little interest or pleasure in doing things",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. Feeling down, depressed, or hopeless",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. Trouble Falling or staying asleep, or sleeping too much",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. Feeling tired or having little energy",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. Poor appetite or overeating",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. Feeling bad about yourself - or that you are a failure or have let yourself or your family down",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. Trouble concentrating on things on things such as reading, the newspaper or watching television",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"8. Moving or speaking so slowly that other people could have noticed? or the opposite - being so fidgety or restless that you have been moving around a lot more han usual.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"9. Thoughts that you would be better off dead or of hurting yourself in some way",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "Not Difficult at all",
                "Somewhat Difficult",
                "Very Difficult",
                "Extremely Difficult"
            ],
            Questions:[
                {
                    Prompt:"If you responded yes to any of the above problems, how difficult have these problems made it for you to do your work, take care of things at home, or get along with other people?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
            ]
        }
    ]
}